//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction, postAction, deleteAction } from '@/api/manage';
import SelectUserModal from "./SelectUserModal";
import UserModal from "./UserModal";
export default {
  name: "DeptUserInfo",
  mixins: [JeecgListMixin],
  components: {
    SelectUserModal: SelectUserModal,
    UserModal: UserModal
  },
  data: function data() {
    return {
      description: '用户信息',
      currentDeptId: '',
      // 表头
      columns: [{
        title: '用户账号',
        align: "center",
        dataIndex: 'username'
      }, {
        title: '用户名称',
        align: "center",
        dataIndex: 'realname'
      }, {
        title: '操作',
        dataIndex: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        align: "center",
        width: 170
      }],
      url: {
        list: "/sys/user/departUserList",
        edit: "/sys/user/editSysDepartWithUser",
        delete: "/sys/user/deleteUserInDepart",
        deleteBatch: "/sys/user/deleteUserInDepartBatch"
      }
    };
  },
  created: function created() {},
  methods: {
    loadData: function loadData(arg) {
      var _this = this;

      if (!this.url.list) {
        this.$message.error("请设置url.list属性!");
        return;
      } //加载数据 若传入参数1则加载第一页的内容


      if (arg === 1) {
        this.ipagination.current = 1;
      }

      if (this.currentDeptId === '') return;
      var params = this.getQueryParams(); //查询条件

      params.depId = this.currentDeptId;
      getAction(this.url.list, params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
        }
      });
    },
    batchDel: function batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error("请设置url.deleteBatch属性!");
        return;
      }

      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = "";

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ",";
        }

        var that = this;
        this.$confirm({
          title: "确认删除",
          content: "是否删除选中数据?",
          onOk: function onOk() {
            deleteAction(that.url.deleteBatch, {
              depId: that.currentDeptId,
              userIds: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    handleDelete: function handleDelete(id) {
      if (!this.url.delete) {
        this.$message.error("请设置url.delete属性!");
        return;
      }

      var that = this;
      deleteAction(that.url.delete, {
        depId: this.currentDeptId,
        userId: id
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadData();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    open: function open(record) {
      this.currentDeptId = record.id;
      this.loadData(1);
    },
    clearList: function clearList() {
      this.currentDeptId = '';
      this.dataSource = [];
    },
    hasSelectDept: function hasSelectDept() {
      if (this.currentDeptId == null) {
        this.$message.error("请选择一个部门!");
        return false;
      }

      return true;
    },
    handleAddUserDepart: function handleAddUserDepart() {
      if (this.currentDeptId == '') {
        this.$message.error("请选择一个部门!");
      } else {
        this.$refs.selectUserModal.visible = true;
      }
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.title = "编辑";
      this.$refs.modalForm.departDisabled = true;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.edit(record);
    },
    handleAdd: function handleAdd() {
      if (this.currentDeptId == '') {
        this.$message.error("请选择一个部门!");
      } else {
        this.$refs.modalForm.departDisabled = true;
        this.$refs.modalForm.userDepartModel.departIdList = [this.currentDeptId]; //传入一个部门id

        this.$refs.modalForm.add();
        this.$refs.modalForm.title = "新增";
      }
    },
    selectOK: function selectOK(data) {
      var _this2 = this;

      var params = {};
      params.depId = this.currentDeptId;
      params.userIdList = [];

      for (var a = 0; a < data.length; a++) {
        params.userIdList.push(data[a]);
      }

      postAction(this.url.edit, params).then(function (res) {
        if (res.success) {
          _this2.$notification.success({
            message: res.message
          });

          _this2.loadData();
        } else {
          _this2.$notification.warning({
            message: res.message
          });
        }
      });
    }
  }
};